import { es as inbound } from "./inbound";
export default {
  inbound,
  welcome: "Bienvenidos",
  login: "Inicio de sesión",
  register: "Registro",
  logout: "Cerrar sesión",
  domains: "Dominios",
  status: "Estado",
  search: "Buscar...",
  actions: "Acciones",
  no_data: "Sin datos",
  loading: "Cargando...",
  date: "Fecha",
  event: "Evento",
  view: "Ver",
  planes: "Planes",

  navigation: {
    context: "Contexto",
    platform_admin: "Administración de plataforma",
    administration: "Administración",
    accounts: "Cuentas",
    users: "Usuarios",
    audit: "Auditoría",
    error_logs: "Log de errores",
    profile: "Perfil",
    home: "Inicio",
    domains: "Dominios",
    emails: "Emails",
    api_keys: "Claves API",
    my_team: "Mi equipo",
    settings: "Ajustes",
    primary: "Navegación principal",
    open_menu: "Abrir navegación",
    close_menu: "Cerrar navegación",
    collapse_menu: "Contraer navegación",
    expand_menu: "Expandir navegación",
    my_account: "Mi cuenta",
    my_profile: "Mi perfil",
    configuration: "Configuración",
    billing: "Facturación",
    notifications: "Notificaciones",
    avatar: "Avatar del usuario",
    default_avatar: "Avatar por defecto",
    context_switch_error: "No se pudo cambiar de contexto.",
  },
  notifications: {
    title: "Notificaciones",
    description: "Invitaciones y avisos de tu cuenta.",
    unread: "No leída",
    view_invitation: "Ver invitación",
    status: {
      accepted: "Aceptada",
      revoked: "Revocada",
      expired: "Caducada",
      unavailable: "No disponible",
    },
  },
  team: {
    invitation: {
      created: "Invitación al equipo creada",
      accepted: "Invitación al equipo aceptada",
    },
    member: {
      added: "Miembro añadido al equipo",
      role_changed: "Rol del miembro actualizado",
      activated: "Miembro del equipo activado",
      deactivated: "Miembro del equipo desactivado",
      removed: "Miembro eliminado del equipo",
    },
    settings: {
      updated: "Ajustes del equipo actualizados",
    },
  },
  members: {
    title: "Mi equipo",
    description: "Gestiona el acceso del equipo. El propietario está protegido.",
    invite_title: "Invitar miembro",
    email_placeholder: "usuario@ejemplo.com",
    add: "Agregar",
    invitation_expiry: "El enlace vence en 7 días y se muestra una sola vez.",
    copy_link: "Copiar enlace",
    user: "Usuario",
    role: "Rol",
    membership: "Membresía",
    since: "Desde",
    owner: "Propietario",
    administrator: "Administrador",
    member: "Miembro",
    active: "Activa",
    inactive: "Inactiva",
    activate: "Activar",
    deactivate: "Desactivar",
    protected: "Protegido",
    no_role: "Sin rol",
    unnamed: "Sin nombre",
    operation_error: "No se pudo completar la operación.",
    invitation_created: "Invitación creada correctamente.",
    role_updated: "Rol actualizado correctamente.",
    status_updated: "Estado actualizado correctamente.",
    remove_title: "¿Eliminar miembro?",
    remove_confirm: "Se eliminará a {email} de esta cuenta.",
    remove: "Eliminar",
    removed: "Miembro eliminado correctamente.",
  },
  invitation: {
    eyebrow: "Invitación de equipo",
    headline: "Tu próximo espacio de trabajo",
    headline_emphasis: "te está esperando.",
    description: "Colabora, gestiona dominios y supervisa tus envíos desde un único lugar.",
    invited_by: "Te invita el equipo",
    protected: "Invitación protegida y vinculada a tu correo.",
    checking: "Comprobando invitación",
    checking_description: "Estamos validando que el enlace siga activo.",
    ready: "Todo listo",
    accepted_title: "Ya formas parte del equipo",
    accepted_description: "La invitación se aceptó correctamente. Puedes continuar a tu panel.",
    go_to_dashboard: "Ir al panel",
    unavailable: "Enlace no disponible",
    open_error_title: "No pudimos abrir la invitación",
    join: "Únete al equipo",
    accept_title: "Acepta tu invitación",
    confirm_details: "Confirma tus datos para entrar en {team}.",
    invited_email: "Correo invitado",
    assigned_role: "Rol asignado",
    available_until: "Disponible hasta",
    existing_account: "Ya tienes una cuenta",
    existing_account_hint: "Acepta con la sesión correspondiente a {email}.",
    accepting: "Aceptando…",
    accept: "Aceptar invitación",
    first_name_placeholder: "Tu nombre",
    last_name_placeholder: "Tu apellido",
    password_placeholder: "Mínimo 6 caracteres",
    hide_password: "Ocultar contraseña",
    show_password: "Mostrar contraseña",
    creating_account: "Creando tu cuenta…",
    create_and_accept: "Crear cuenta y aceptar",
    terms: "Al continuar, crearás una cuenta vinculada al correo invitado.",
    footer: "Infraestructura de email para equipos",
    default_expiration: "7 días desde el envío",
    login_required: "Inicia sesión con el correo invitado y vuelve a abrir este enlace.",
    accept_error: "No se pudo aceptar la invitación. Inténtalo de nuevo.",
    expired_error: "El enlace puede haber caducado o ya no estar activo.",
  },
  forbidden: {
    title: "Acceso denegado",
    description: "No tienes permisos para acceder a esta sección.",
  },
  admin: {
    dashboard: {
      title: "Administración",
      subtitle: "Resumen global de Destinatarium",
      view_users: "Ver usuarios",
      view_accounts: "Ver cuentas",
      active_accounts: "{count} activas",
      last_seven_days: "{count} en los últimos 7 días",
    },
    accounts: {
      title: "Cuentas",
      search: "Buscar cuenta…",
      account: "Cuenta",
      access: "Acceso",
      members: "Miembros",
      subscription: "Suscripción",
      active: "Activa",
      inactive: "Inactiva",
      blocked: "Bloqueada",
      available: "Disponible",
      blocked_users: "{count} usuario | {count} usuarios",
      view_attempts: "Ver intentos de acceso",
      view_account: "Ver cuenta",
      login_attempts: "Intentos de acceso",
      close_history: "Cerrar historial",
      back: "Volver a cuentas",
      detail: "Detalle de cuenta",
      created_at: "Creada el {date}",
      recipients: "Destinatarios",
      last_seven_days: "Últimos 7 días",
      status: "Estado",
      no_subscription: "Sin suscripción",
      provider: "Proveedor",
      plan_price: "Plan / precio",
      next_renewal: "Próxima renovación",
      period_end: "Fin del período",
      email_usage: "Consumo de emails",
      used_of: "de {limit}",
      quota_percentage: "Porcentaje de cuota utilizada",
      percent_used: "{percent}% utilizado",
      available_count: "{count} disponibles",
      quota_unconfigured: "La cuota de esta cuenta todavía no está configurada.",
      period: "Período: {start} — {end}",
      users_roles: "Usuarios y roles",
      account_roles: "Roles en la cuenta",
      no_assigned_role: "Sin rol asignado",
      no_users: "Esta cuenta no tiene usuarios asociados.",
      not_found: "Cuenta no encontrada.",
      load_error: "No se pudo cargar la cuenta.",
    },
    users: {
      title: "Usuarios",
      search: "Nombre o email…",
      all_statuses: "Todos los estados",
      active_plural: "Activos",
      inactive_plural: "Inactivos",
      all_roles: "Todos los roles",
      all_accounts: "Todas las cuentas",
      user: "Usuario",
      access: "Acceso",
      roles: "Roles",
      accounts: "Cuentas",
      created: "Creación",
      active: "Activo",
      inactive: "Inactivo",
      blocked: "Bloqueado",
      available: "Disponible",
      no_roles: "Sin roles",
      no_account: "Sin cuenta",
      view_user: "Ver usuario",
      unnamed: "Sin nombre",
      back: "Volver a usuarios",
      email_verified: "Email verificado",
      yes: "Sí",
      no: "No",
      information: "Información",
      phone: "Teléfono",
      last_access: "Último acceso",
      updated: "Actualización",
      platform_roles: "Roles de plataforma",
      no_platform_roles: "Este usuario no tiene roles de plataforma.",
      memberships_roles: "Membresías y roles",
      account_status: "Estado de cuenta",
      membership: "Membresía",
      since: "Desde",
      no_role: "Sin rol",
      no_accounts: "Este usuario no pertenece a ninguna cuenta.",
      recent_attempts: "Intentos de acceso recientes",
      last_ten: "Últimos 10",
      not_found: "Usuario no encontrado.",
      load_error: "No se pudo cargar el usuario.",
    },
    audit: {
      title: "Auditoría",
      filter_action: "Filtrar por acción…",
      actor: "Actor",
      action: "Acción",
      resource: "Recurso",
    },
    error_logs: {
      title: "Log de errores",
      subtitle: "Incidencias registradas por la plataforma",
      refresh: "Actualizar",
      filters_label: "Filtros del log de errores",
      search: "Buscar por mensaje, código u origen…",
      level: "Nivel",
      all_levels: "Todos los niveles",
      source: "Origen",
      message: "Mensaje",
      code: "Código",
      detail: "Detalle",
      show_detail: "Ver detalle",
      hide_detail: "Ocultar detalle",
      context: "Contexto",
      stack_trace: "Stack trace",
      unavailable: "No disponible",
      levels: {
        critical: "Crítico",
        error: "Error",
        warning: "Aviso",
        info: "Información",
        debug: "Debug",
      },
    },
    emails: {
      title: "Correos",
      subtitle: "Envíos de todas las cuentas de la plataforma",
      refresh: "Actualizar",
      filters_label: "Filtros de correos",
      search: "Email, nombre o asunto exacto…",
      search_hint: "La búsqueda es exacta para proteger los datos cifrados.",
      all_accounts: "Todas las cuentas",
      all_statuses: "Todos los estados",
      message: "Mensaje",
      route: "Remitente / destinatario",
      no_subject: "Sin asunto",
      view_detail: "Ver detalle del email",
      statuses: {
        scheduled: "Programado",
        sending: "Enviando",
        sent: "Enviado",
        delivered: "Entregado",
        delayed: "Retrasado",
        bounced: "Rebotado",
        failed: "Fallido",
        outcome_unknown: "Resultado desconocido",
        suppressed: "Suprimido",
        canceled: "Cancelado",
        unknown: "Desconocido",
      },
    },
    domains: {
      title: "Dominios",
      subtitle: "Dominios de todas las cuentas de la plataforma",
      refresh: "Actualizar",
      filters_label: "Filtros de dominios",
      search: "Buscar dominio…",
      all_accounts: "Todas las cuentas",
      all_statuses: "Todos los estados",
      domain: "Dominio",
      created: "Creación",
      pending: "Pendiente",
      active: "Activo",
      unknown_status: "Estado desconocido",
    },
    common: {
      status: "Estado",
      actions: "Acciones",
      date: "Fecha",
      account: "Cuenta",
      email: "Email",
      domains: "Dominios",
      read_only: "Solo lectura",
      deleted_user: "Usuario eliminado",
      unknown: "Desconocido",
    },
    attempts: {
      user: "Usuario",
      result: "Resultado",
      success: "Correcto",
      invalid_credentials: "Credenciales inválidas",
      rate_limited: "Bloqueado",
      blocked: "Bloqueado",
    },
  },
  roles: {
    platform_admin: "Administrador de plataforma",
    team_owner: "Propietario",
    team_admin: "Administrador",
    team_member: "Miembro",
  },
  list_state: {
    loading_users: "Cargando usuarios…",
    loading_accounts: "Cargando cuentas…",
    loading_events: "Cargando eventos…",
    loading_error_logs: "Cargando errores…",
    loading_admin_emails: "Cargando correos…",
    loading_admin_domains: "Cargando dominios…",
    loading_members: "Cargando miembros…",
    loading_notifications: "Cargando notificaciones…",
    loading_statistics: "Cargando estadísticas…",
    loading_account: "Cargando cuenta…",
    loading_user: "Cargando usuario…",
    loading_attempts: "Cargando intentos…",
    loading_billing: "Cargando información de facturación…",
    empty_users: "No hay usuarios para mostrar.",
    empty_accounts: "No hay cuentas para mostrar.",
    empty_events: "No hay eventos.",
    empty_error_logs: "No hay errores para mostrar.",
    empty_admin_emails: "No hay correos para mostrar.",
    empty_admin_domains: "No hay dominios para mostrar.",
    empty_members: "No hay miembros.",
    empty_notifications: "No tienes notificaciones.",
    empty_attempts: "No hay intentos registrados.",
    error_users: "No se pudieron cargar los usuarios.",
    error_accounts: "No se pudieron cargar las cuentas.",
    error_events: "No se pudo cargar la auditoría.",
    error_error_logs: "No se pudo cargar el log de errores.",
    error_admin_emails: "No se pudieron cargar los correos.",
    error_admin_domains: "No se pudieron cargar los dominios.",
    error_members: "No se pudieron cargar los miembros.",
    error_notifications: "No se pudieron cargar las notificaciones.",
    error_statistics: "No se pudo cargar el resumen.",
    error_attempts: "No se pudieron cargar los intentos de acceso.",
  },
  pagination: {
    items: "{count} elementos",
    showing: "Mostrando",
    of: "de",
    records: "registros",
    rows: "Filas",
    previous: "Anterior",
    page: "Página",
    next: "Siguiente",
    per_page: "{count} por página",
  },

  auth_local: {
    recover: "Recuperar contraseña",
    reset: "Guardar nueva contraseña",
    google: "Continuar con Google",
    link_google: "Vincular Google",
    google_pending: "El acceso con Google no está disponible en este momento.",
    recover_email_hint: "Si la cuenta existe, recibirás un correo con el enlace para restablecer tu contraseña.",
    refresh: "Actualizar buzón",
    mailbox: "Buzón local de pruebas",
    mailbox_hint: "Los emails se capturan aquí; no se envían. El buzón se vacía al reiniciar el servidor.",
    mail_verification: "Verificar email",
    mail_reset: "Restablecer contraseña",
    callback: "URI de redirección para configurar en Google Cloud:",
    recover_hint: "Si la cuenta existe, encontrarás el enlace en el buzón local.",
    reset_done: "Contraseña actualizada. Ya puedes iniciar sesión.",
    oauth_error: "Google no completó el acceso: {error}. Vuelve al inicio de sesión e inténtalo nuevamente.",
    oauth_account_not_linked: "No pudimos vincular Google con tu cuenta. Comprueba que Google haya verificado tu correo o inicia sesión con tu contraseña para vincularlo.",
    callback_title: "Completando el acceso a Destinatarium",
    onboarding_title: "Completa tu perfil",
    onboarding_hint: "Necesitamos tu nombre y apellido para completar el alta de tu cuenta y equipo.",
    complete: "Completar registro",
    database: "Base de datos local",
  },
  auth: {
    tagline_start: "Así debería sentirse",
    tagline_emphasis: "enviar emails.",
    description:
      "Infraestructura de email transaccional rápida, confiable y fácil de usar.",
    reliable_delivery: "Entrega confiable",
    reliable_delivery_description: "Más inbox, menos spam",
    fast_api: "API rápida",
    fast_api_description: "Integración en minutos",
    security_first: "Seguridad primero",
    security_first_description: "Protegemos tus datos",
    welcome_back: "Bienvenido de nuevo",
    login_subtitle: "Ingresa tus credenciales para continuar",
    no_account: "¿No tienes cuenta?",
    create_account: "Crear cuenta",
    register_subtitle: "Empieza a enviar emails hoy mismo",
    already_have_account: "¿Ya tienes cuenta?",
    logging_in: "Iniciando sesión…",
    login_failed: "No se pudo iniciar sesión. Revisa tus credenciales e inténtalo de nuevo.",
    check_your_email: "Revisa tu correo",
    check_your_email_help: "Te enviamos un correo de verificación. Ábrelo y haz clic en el enlace para activar tu cuenta. El enlace caduca en 24 horas.",
    verifying_email: "Verificando tu email…",
    verifying_email_help: "Estamos validando el enlace de verificación.",
    confirm_email: "Confirma tu dirección de email",
    confirm_email_help: "Pulsa el botón para completar la verificación de tu cuenta.",
    confirm_email_button: "Confirmar mi email",
    email_verified: "Email verificado",
    email_verified_help: "Tu cuenta ya está activa. Puedes iniciar sesión.",
    verification_failed: "No pudimos verificar el email",
    verification_failed_help: "El enlace no es válido o ha caducado. Solicita uno nuevo.",
    resend_verification: "Reenviar correo de verificación",
    sending_verification: "Enviando…",
    verification_resent: "Solicitud procesada correctamente. Si la cuenta está pendiente, recibirás un nuevo correo.",
    verification_resend_failed: "No pudimos reenviar el correo. Inténtalo nuevamente.",
    back_to_login: "Volver al inicio de sesión",
  },

  dashboard: {
    title: "Resumen",
    welcome: "¡Qué bueno verte de nuevo, {name}! 👋",
    trend_7d: "{value}% vs. 7 días",
    kpis: {
      domains: "Dominios",
      emails: "Emails",
      pending_dns: "DNS pendientes",
      approved: "Aprobados",
    },
    charts: {
      domains_by_status: "Dominios por estado",
      emails_by_status: "Emails por estado",
      total: "Total",
    },
    status: {
      pending_dns: "DNS pendiente",
      approved: "Aprobado",
    },
    guide: {
      title: "Envía tu primer email",
      description: "Configura tu cuenta y realiza tu primer envío en 5 pasos.",
      progress: "{completed} de {total} completados",
      progress_label: "Progreso de configuración",
      review: "Revisar",
      review_dns: "Revisar DNS",
      complete_title: "¡Configuración completada!",
      complete_description: "Tu cuenta está lista y ya has comprobado tu primer envío.",
      status: {
        waiting_verification: "Esperando verificación",
        processing_delivery: "Procesando el envío",
        sent_waiting_delivery: "Enviado; esperando confirmación de entrega",
        delivery_unconfirmed: "Entrega no confirmada; revisa el resultado",
      },
      steps: {
        domain: {
          title: "Añade un dominio",
          description: "Indica el dominio que usarás como remitente.",
          action: "Añadir dominio",
        },
        dns: {
          title: "Configura y verifica el DNS",
          description: "Publica los registros requeridos y espera su aprobación.",
          action: "Configurar DNS",
        },
        api_key: {
          title: "Crea una clave API",
          description: "Genera la credencial que usará tu aplicación.",
          action: "Crear clave API",
        },
        test_email: {
          title: "Envía un email de prueba",
          description: "Haz tu primer envío desde el dominio verificado.",
          action: "Enviar prueba",
        },
        result: {
          title: "Comprueba el resultado",
          description: "Revisa el estado final y confirma la entrega.",
          action: "Ver resultados",
        },
      },
    },
    tip: {
      title: "Consejo:",
      text: "Añade más dominios y empieza a enviar emails para ver cómo evolucionan tus estadísticas.",
      action: "Añadir dominio",
    },
  },

  subscription: {
    plans: "Planes",
    subtitle: "Elige el plan que mejor acompaña el crecimiento de tu equipo.",
    current_plan: "Plan actual",
    month: "mes",
    year: "año",
    monthly: "Mensual",
    yearly: "Anual",
    billing_cycle: "Frecuencia de facturación",
    loading_plans: "Cargando planes…",
    load_error: "No pudimos cargar los planes. Inténtalo nuevamente.",
    retry: "Reintentar",
    no_active_plans: "No hay planes activos disponibles.",
    most_used: "Más popular",
    custom_price: "Personalizado",
    processing_payment: "Esperando la confirmación segura del pago…",
    scheduled_change: "Hay un cambio de suscripción programado.",
    scheduled_change_date: "Hay un cambio de suscripción programado para el {date}.",
    checkout_unavailable_title: "Pago no disponible",
    checkout_unavailable_text: "La configuración de pago no está disponible.",
    cancel_title: "¿Cancelar la suscripción?",
    cancel_text: "Mantendrás el acceso de pago hasta que Paddle aplique la cancelación programada.",
    continue: "Continuar",
    confirm_change_title: "Confirmar cambio de plan",
    confirm_change_text: "Paddle calculará el cambio con prorrateo inmediato. Cualquier importe pendiente podría cobrarse ahora.",
    confirm_change: "Confirmar cambio",
    billing_updated_title: "Facturación actualizada",
    billing_updated_text: "Paddle confirmó la operación.",
    subscription_active_title: "Suscripción activa",
    subscription_active_text: "Tu nuevo plan está listo.",
    payment_received_title: "Pago recibido",
    payment_received_text: "Paddle todavía está confirmando tu suscripción. El plan se activará automáticamente.",
    change_requested_title: "Cambio solicitado",
    change_requested_text: "La suscripción se actualizará cuando Paddle confirme el cambio.",
    custom_plan_contact_title: "Contacta con nosotros",
    custom_plan_contact_message:
      "Escríbenos a plans@destinatarium.com para contratar un plan personalizado.",
    plan_cycle_monthly_msg: "2 meses gratis con anual\u00A0🎁",
    plan_cycle_yearly_msg: "¡2 meses gratis para ti!\u00A0🎉",
    plan_names: {
      free: "Gratis",
      starter: "Starter",
      flow: "Flow",
      growth: "Growth",
      enterprise: "Enterprise",
    },
    plan_taglines: {
      free: "Para empezar",
      starter: "Ya estás en marcha",
      flow: "Todo empieza a fluir",
      growth: "Listo para crecer",
      enterprise: "Hecho a tu medida",
    },
    plan_actions: {
      upgrade: "Mejorar plan",
      downgrade: "Cambiar a este plan",
      contact: "Contactar",
      active: "Activo",
      unavailable: "No disponible",
      processing: "Procesando…",
    },
    plan_features: {
      free: {
        emails: "4,000 emails/mes",
        additional_emails: "Emails adicionales no disponibles",
        no_card: "No se requiere tarjeta de crédito",
        retention: "7 días de retención de datos",
        domains: "3 dominios",
        senders: "1 remitente",
        ip: "IP compartida",
        support: "Soporte email",
      },
      starter: {
        emails: "8,000 emails",
        additional_emails: "$1.00 por cada 1,000 emails adicionales",
        retention: "15 días de retención de datos",
        domains: "5 dominios",
        senders: "10 remitentes",
        ip: "IP compartida",
        support: "Soporte prioritario",
      },
      flow: {
        emails: "60,000 emails",
        additional_emails: "$0.90 por cada 1,000 emails adicionales",
        retention: "30 días de retención de datos",
        domains: "15 dominios",
        senders: "10 remitentes",
        ip: "IP compartida",
        support: "Soporte prioritario",
      },
      growth: {
        emails: "100,000 emails",
        additional_emails: "$0.75 por cada 1,000 emails adicionales",
        retention: "90 días de retención de datos",
        domains: "100 dominios",
        senders: "1,000 remitentes",
        ip: "IP dedicada con add-on",
        support: "Soporte 24/7",
      },
      enterprise: {
        volume_pricing: "Precios por volumen",
        additional_emails: "Emails adicionales a precio personalizado",
        domains: "Dominios personalizados",
        senders: "Remitentes personalizados",
        sla: "SLA",
        onboarding: "Onboarding",
        consulting: "Consultoría",
        ip: "IP dedicada con add-on",
        support: "Discord dedicado",
      },
    },
  },
  button: {
    login: "Iniciar sesión",
    connect: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
    cancel: "Cancelar",
    save: "Guardar",
    back: "Atrás",
    close: "Cerrar",
  },
  error: {
    title: "Error",
    generic: "Ha ocurrido un error. Inténtalo de nuevo.",
    connection: "No se pudo conectar con el servidor. Verifica tu conexión a internet.",
    resource_not_found: "Error {statusCode}: Recurso no encontrado.",
    fetch_emails: "Error al cargar los emails.",
  },
  user: {
    first_name: "Nombre",
    last_name: "Apellido",
    email: "Correo electrónico",
    password: "Contraseña",
    password_confirmation: "Confirmar contraseña",
    error: {
      user_already_exist: "El usuario ya existe",
      passwords_do_not_match: "Las contraseñas no coinciden",
      data_incomplete: "Por favor, complete todos los campos obligatorios",
      required: "Este campo es obligatorio",
    },
  },
  domain: {
    vercel: {
      description: "Conecta tu cuenta para cargar automáticamente los registros de Postal en Vercel DNS.",
      connected: "Vercel conectado a este equipo. Configura los DNS desde las acciones de cada dominio.",
      not_configured: "La integración OAuth necesita ser configurada por el administrador de Destinatarium.",
      connect: "Conectar Vercel",
      disconnect: "Desconectar Vercel",
      refresh: "Actualizar",
      connection_success: "Vercel conectado correctamente.",
      disconnect_hint: "Se eliminará la conexión de este equipo en Destinatarium. Los registros DNS permanecerán en Vercel. Para revocar también la autorización, desinstala Destinatarium desde Integrations en Vercel.",
      configure_dns: "Configurar DNS en Vercel",
      connect_first: "Conecta Vercel para cargar los registros DNS de Postal.",
      loading_domains: "Comprobando los dominios de Vercel…",
      domains_failed: "No se pudieron comprobar los dominios. Revisa el aviso de Vercel y pulsa Actualizar.",
      domain_unavailable: "El dominio no aparece en la cuenta de Vercel conectada. Comprueba el equipo seleccionado y pulsa Actualizar.",
      external_dns: "DNS externo a Vercel",
      choose_domain: "Elegir un dominio de Vercel",
      manual_domain: "Ingresar otro dominio manualmente",
      preview_hint: "Estos son los registros actuales de Postal para la zona {zone}. Se volverán a comprobar al aplicarlos.",
      conflict_hint: "Hay registros incompatibles. Revisa los señalados en Vercel antes de continuar. SPF debe tener un único registro; los MX existentes pueden pertenecer a tu proveedor de correo entrante.",
      apply: "Cargar registros DNS",
      applying: "Cargando registros…",
      result: "Creados: {created}. Ya existentes: {existing}.",
      propagation: "Los cambios necesitan propagarse. Usa Ver DNS para volver a comprobar el estado en Postal.",
      partial: "La carga se interrumpió. Cierra y vuelve a abrir esta ventana para actualizar el estado y reintentar los registros que faltan.",
      actions: { create: "Se creará", exists: "Ya existe", conflict: "Conflicto" },
      errors: {
        vercel_not_configured: "La integración de Vercel todavía no está configurada.",
        vercel_oauth_failed: "No se pudo completar la autorización. Vuelve a conectar Vercel.",
        vercel_invalid_state: "La autorización venció, ya fue usada o pertenece a otro usuario/equipo. Vuelve a iniciar la conexión desde el equipo correcto.",
        vercel_already_connected: "Esta instalación de Vercel ya está vinculada a otro equipo de Destinatarium.",
        vercel_not_connected: "Conecta Vercel antes de configurar los DNS.",
        vercel_access_denied: "Vercel rechazó el acceso. Revisa los permisos de dominios de la integración o vuelve a conectar la cuenta.",
        vercel_rate_limited: "Vercel alcanzó el límite de solicitudes. Espera y vuelve a intentarlo.",
        vercel_not_found: "El recurso no está disponible en la cuenta de Vercel conectada.",
        vercel_domain_not_found: "El dominio no está disponible en la cuenta o equipo de Vercel conectado.",
        vercel_external_dns: "Este dominio no usa Vercel DNS. Configura los registros en su proveedor DNS actual.",
        vercel_dns_conflict: "Hay registros DNS incompatibles. Actualiza la vista y revisa los conflictos en Vercel.",
        vercel_request_failed: "No se pudo completar la solicitud a Vercel. Vuelve a intentarlo.",
        vercel_invalid_response: "Vercel devolvió una respuesta inesperada. Vuelve a intentarlo.",
        vercel_pagination_limit: "La cuenta excede el límite de registros consultables en una operación.",
        vercel_invalid_dns_record: "Postal devolvió un registro DNS que no se puede cargar en Vercel.",
        vercel_no_dns_records: "No se recibió una configuración completa de SPF y DKIM desde Postal.",
      },
    },
    domain: "Dominio",
    add_domain: "Agregar dominio",
    edit_domain: "Editar dominio",
    delete_domain: "Eliminar dominio",
    delete_confirm_title: "¿Eliminar dominio?",
    delete_confirm_text: "Se eliminará {domain} de Destinatarium y Postal.",
    deleting: "Eliminando...",
    domain_name: "Nombre del dominio",
    domain_description: "Descripción del dominio",
    domain_status: "Estado del dominio",
    domain_status_pending: "Pendiente",
    domain_status_approved: "Aprobado",
    domain_status_rejected: "Rechazado",
    domain_status_error: "Error al cambiar el estado del dominio",
    domain_list_empty: "No hay dominios disponibles",
    domains: "Dominios",
    domain_list: "Listado de dominios",
    empty_state: {
      title: "Añade tu primer dominio",
      description: "Conecta un dominio para verificarlo, configurar sus DNS y empezar a enviar emails.",
      action: "Añadir mi primer dominio",
    },
    view_dns: "Ver DNS config",
    no_dns_info: "No hay información DNS disponible.",
    error_fetching_dns: "Error al cargar la información DNS.",
    domain_status_array: {
      pending: "Pendiente",
      pendingDNS: "Pendiente DNS",
      approved: "Aprobado",
    },
    success: {
      domain_added: "Dominio agregado exitosamente",
      domain_deleted: "Dominio eliminado exitosamente",
    },
    error: {
      fetching_domains: "Error al cargar los dominios. Inténtalo de nuevo.",
      fetching_domains_detail: "Error al cargar los dominios: {error}",
    },
    dns: {
      verification_status: "Estado de verificación",
      ownership_verification: "Verificación de propiedad",
      host: "Host",
      type: "Tipo",
      value: "Valor",
      priority: "Prioridad",
      valid: "Válido",
      pending: "Pendiente",
      mx_records: "Registros MX",
      spf_record: "Registro SPF",
      dkim_record: "Registro DKIM",
      dmarc_record: "Registro DMARC",
      return_path: "Ruta de retorno",
      copy_dkim: "Copiar DKIM",
      optional: "Registros opcionales",
      notes: "Notas",
      copy_json: "Copiar JSON",
      copy_instructions: "Copiar instrucciones",
      input_hint: "Ingresa el dominio sin http(s) ni www.",
      notes_review_invalid: "Revisa los registros marcados como inválidos para completar la configuración DNS.",
      notes_rerun_verification: "Después de aplicar los cambios DNS, ejecuta nuevamente la verificación.",
      notes_optional_mail: "Opcional. Úsalo solo si los clientes necesitan mail.tudominio para IMAP/SMTP.",
      notes_optional_autodiscover: "Opcional. Configuración automática de clientes como Outlook y Thunderbird.",
      notes_optional_autoconfig: "Opcional. Configuración automática de clientes de correo.",
      notes_ptr: "Asegúrate de que el PTR (DNS inverso) de la IP apunte a mail.krabbysystem.com.",
      notes_tls: "Usa certificados TLS válidos para mail.krabbysystem.com (Let's Encrypt).",
      notes_dmarc: "Después de validar la entrega, puedes subir DMARC a p=quarantine o p=reject.",
    },
  },
  api_keys: {
    help: {
      button: "Cómo usar la clave",
      title: "Usar tu clave API",
      intro: "Conecta tu servidor con Destinatarium para enviar emails mediante la API.",
      send_only: "Tu API key y el SDK solo permiten enviar emails de tu cuenta. No permiten consultar datos ni acceder a funciones administrativas de Destinatarium.",
      examples_label: "Método de integración",
      node_title: "Enviar con el SDK Node.js",
      node_install_step: "1. Instala el SDK",
      node_requirements: "Requiere Node.js 18 o posterior. Instala el SDK en el proyecto de tu servidor:",
      copy_install: "Copiar instalación",
      node_example_step: "2. Copia el ejemplo",
      node_hint: "Configura la variable de entorno DESTINATARIUM_API_KEY en tu servidor con tu clave completa. Guarda este ejemplo como send-email.mjs y reemplaza el remitente por una dirección de tu dominio verificado y el destinatario por la dirección de destino.",
      node_run_step: "3. Ejecuta el ejemplo",
      node_run_hint: "Desde la carpeta de tu proyecto, con la variable de entorno configurada, ejecuta:",
      node_idempotency: "El SDK añade automáticamente la autenticación Bearer y una clave de idempotencia por envío, conservándola en sus reintentos para evitar duplicados.",
      node_docs: "Ver documentación del SDK en npm",
      idempotency_title: "Idempotencia opcional: evitar duplicados al reintentar",
      idempotency_hint: "El ejemplo básico funciona sin este encabezado. Si vas a reintentar una solicitud, agrega Idempotency-Key con un identificador único para ese envío. Conserva el mismo identificador y contenido al reintentar; usa uno nuevo para otro envío.",
      create_step: "Crea una clave y copia su valor completo: solo se muestra una vez. La clave enmascarada de la lista no sirve para autenticarte.",
      domain_step: "Agrega y verifica el dominio del remitente en Dominios antes de enviar.",
      auth_step: "Envía la clave en el encabezado de cada solicitud:",
      example_title: "Ejemplo con cURL",
      example_hint: "Ejecuta este ejemplo desde tu servidor o terminal. Reemplaza YOUR_API_KEY por tu clave completa, y cambia el remitente y el destinatario. El remitente debe pertenecer a tu dominio verificado.",
      copy_example: "Copiar ejemplo",
      example_copied: "Ejemplo copiado.",
      response_title: "¿Qué significa la respuesta?",
      response_hint: "Una respuesta exitosa confirma que el email quedó en la cola. El envío y la entrega se procesan después; consulta sus estados en Emails. No significa entrega inmediata.",
      errors_title: "Errores comunes",
      error_401: "La clave falta, no es válida o fue revocada.",
      error_403: "Revisa los permisos de la clave y el dominio verificado del remitente.",
      error_429: "Se alcanzó un límite de solicitudes o cuota; revisa la respuesta y Retry-After si está presente.",
      security: "Guarda la clave en una variable de entorno de tu servidor. No la incluyas en código del navegador ni repositorios públicos. Si se expone, revócala y crea otra.",
      example_subject: "Hola desde Destinatarium",
      example_api_text: "Tu primer email usando la API.",
      example_sdk_text: "Tu primer email usando el SDK.",
    },
    title: "Claves API",
    create: "Crear clave API",
    description: "Administra tus claves API para acceder de forma programática.",
    key: "Clave API",
    permissions: "Permisos",
    no_permissions: "Sin permisos",
    scope_labels: {
      emails_send: "Enviar emails",
      emails_read: "Consultar emails",
    },
    created_at: "Creada el",
    actions: "Acciones",
    revoke: "Revocar",
    revoking: "Revocando...",
    empty: "Todavía no hay claves API.",
    empty_state: {
      title: "Crea tu primera clave API",
      description: "Con una clave API podrás conectar tu servidor y empezar a enviar emails de forma segura.",
      action: "Crear mi primera clave",
    },
    new_key: "Nueva clave API (cópiala ahora):",
    copy: "Copiar clave API",
    one_time_notice: "Este valor no volverá a mostrarse.",
    name: "Nombre",
    name_placeholder: "API de producción",
    name_required: "Ingresa un nombre para la clave API.",
    name_too_long: "El nombre no puede superar los 100 caracteres.",
    copy_error: "No se pudo copiar la clave API.",
    copy_success: "Clave API copiada al portapapeles.",
    revoke_title: "¿Revocar la clave API?",
    revoke_warning: "Las aplicaciones que usen esta clave perderán el acceso inmediatamente.",
    revoked_success: "Clave API revocada.",
    errors: {
      name_exists: "Ya existe una clave API con este nombre.",
      invalid_name: "El nombre de la clave API debe tener entre 1 y 100 caracteres.",
      invalid_scopes: "Los permisos seleccionados para la clave API no son válidos.",
      invalid_request: "La solicitud de la clave API no es válida.",
    },
  },
  email: {
    email: "Email",
    emails: "Emails",
    add_email: "Agregar email",
    edit_email: "Editar email",
    delete_email: "Eliminar email",
    email_from: "De",
    email_to: "Para",
    email_cc: "CC",
    email_bcc: "BCC",
    email_reply_to: "Responder a",
    email_cc_hint: "Destinatarios en copia (opcional)",
    email_bcc_hint: "Destinatarios en copia oculta (opcional)",
    email_reply_to_hint: "Dirección de respuesta (opcional)",
    email_from_hint: "Admite el formato «Nombre <email{'@'}dominio.com>»",
    email_to_hint: "Admite el formato «Nombre <email{'@'}dominio.com>» o una lista separada por comas",
    html_content: "Contenido HTML",
    html_content_hint: "Contenido HTML del email",
    show_advanced: "Mostrar opciones avanzadas",
    hide_advanced: "Ocultar opciones avanzadas",
    email_subject: "Asunto",
    email_text: "Texto del email",
    email_html: "HTML del email",
    email_status_str: "Estado del email",
    email_status: {
      scheduled: "Programado",
      sending: "Enviando",
      sent: "Enviado",
      bounced: "Rebotado",
      failed: "Fallido",
      canceled: "Cancelado",
      outcome_unknown: "Resultado desconocido",
      suppressed: "Suprimido",
      delayed: "Retrasado",
      delivered: "Entregado",
    },
    email_list_empty: "No hay emails disponibles",
    email_list: "Listado de emails",
    send_email: "Enviar email",
    empty_state: {
      title: "Tu primer email está por salir",
      description: "Cuando envíes un email, podrás seguir su recorrido desde aquí.",
      action: "Enviar mi primer email",
      help: "Ver cómo funciona",
    },
    scheduled_at: "Programado para",
    schedule_delivery: "Programar para más tarde",
    delivery_date_time: "Fecha y hora de envío",
    timezone: "Zona horaria",
    schedule_preview: "Hora exacta de envío",
    schedule_required: "Selecciona la fecha y hora de envío.",
    invalid_schedule: "Esa hora local no existe en la zona horaria seleccionada.",
    errors: {
      scheduled_at_in_past: "La fecha y hora de envío debe ser posterior a la hora actual.",
    },
    detail: "Detalle del Email",
    detail_short: "Detalle",
    breadcrumb_label: "Ruta de navegación",
    no_subject: "Sin asunto",
    copy_id: "Copiar ID",
    copied: "Copiado",
    copied_to_clipboard: "Copiado al portapapeles",
    copy_value: "Copiar valor",
    shipment_information: "Información del envío",
    email_journey: "Recorrido del email",
    email_id: "ID del email",
    message_id: "Message ID",
    requested_by_api_key: "Solicitado con clave API",
    domain: "Dominio",
    size: "Tamaño",
    format: "Formato",
    technical_details: "Detalles técnicos",
    plain_text: "Texto plano",
    preview_mode: "Formato de vista previa",
    html_preview_title: "Vista previa HTML del email",
    event: "Evento",
    event_recorded: "El evento quedó registrado correctamente.",
    retry: "Reintentar",
    detail_load_error: "No pudimos cargar este email",
    detail_load_error_hint: "Comprueba la conexión o vuelve a intentarlo en unos instantes.",
    events: "Eventos",
    attachments: "Archivos adjuntos",
    no_attachments: "No hay archivos adjuntos",
    inline: "En línea",
    download: "Descargar",
    attach_files: "Adjuntar archivos",
    no_files_selected: "Ningún archivo seleccionado",
    files_selected: "{count} archivos seleccionados",
    attachments_hint: "Hasta 20 archivos y 40 MiB en Base64. Imágenes: máximo 5 MiB originales y 400×400 px.",
    inline_image: "Imagen en línea",
    cid_hint: "Insertada automáticamente en el HTML como",
    remove_attachment: "Quitar",
    too_many_attachments: "Puedes adjuntar hasta 20 archivos.",
    attachments_too_large: "Los adjuntos superan el límite Base64 de 40 MiB.",
    empty_attachment: "No se pueden adjuntar archivos vacíos.",
    attachment_read_error: "No se pudo leer el archivo adjunto.",
    inline_attachment_error: "No se pudieron cargar una o varias imágenes inline del email.",
    image_too_large: "Cada imagen original puede pesar como máximo 5 MiB.",
    image_processing_error: "No se pudo redimensionar u optimizar la imagen.",
    image_dimensions_too_large: "Este formato no se puede redimensionar automáticamente; usa una imagen de hasta 400×400 px.",
    invalid_content_id: "Las imágenes en línea necesitan un content_id único y seguro para URL.",
    preview: "Vista previa del Email",
    event_types: {
      sent: "Email Enviado",
      delivered: "Entregado",
      bounced: "Rebotado",
      opened: "Abierto",
      clicked: "Enlace Clickeado",
      unsubscribe: "Desuscrito",
      complained: "Reportado como Spam",
      canceled: "Cancelado",
      delivery_delayed: "Entrega Retrasada",
      failed: "Falló",
      scheduled: "Programado",
      processing: "Procesando",
    },
    event_descriptions: {
      delivered: "El proveedor de destino confirmó la entrega.",
      sent: "El mensaje fue aceptado para su entrega.",
      processing: "El mensaje se preparó correctamente.",
      scheduled: "El mensaje fue programado para envío.",
      opened: "El destinatario abrió el mensaje.",
      clicked: "El destinatario abrió un enlace del mensaje.",
      bounced: "El servidor de destino rechazó el mensaje.",
      failed: "No se pudo completar la entrega.",
      complained: "El destinatario marcó el mensaje como spam.",
      unsubscribe: "El destinatario solicitó darse de baja.",
      canceled: "El envío fue cancelado.",
      delivery_delayed: "El proveedor retrasó temporalmente la entrega.",
    },
    success: {
      send_email:
        "Tu mensaje ha sido encolado y será enviado en los próximos minutos",
    },
  },

  settings: {
    title: "Ajustes",
    usage: "Uso",
    billing: "Facturación",
    profile: "Perfil",
    team: "Global",
    team_section: {
      title: "Configuración del equipo",
      subtitle: "Define la zona horaria predeterminada para programar y mostrar los envíos.",
      timezone: "Zona horaria predeterminada",
      timezone_hint: "Cada envío guarda también la zona horaria seleccionada para auditoría.",
      save: "Guardar configuración",
      saved: "La zona horaria del equipo se actualizó correctamente.",
    },
    billing_section: {
      title: "Facturación",
      subtitle: "Consulta tu plan, el estado de la suscripción y las próximas renovaciones.",
      plan: "Plan actual",
      status: "Estado",
      next_billing_date: "Próxima fecha de facturación",
      scheduled_change: "Cambio programado",
      opening: "Abriendo…",
      manage_in_paddle: "Gestionar facturación en Paddle",
      free_plan_hint: "Los métodos de pago y las facturas aparecerán cuando te suscribas a un plan de pago.",
      plan_fallback: "Plan {id}",
      statuses: {
        free: "Gratis",
        active: "Activa",
        trialing: "En prueba",
        past_due: "Pago pendiente",
        paused: "Pausada",
        canceled: "Cancelada",
        cancelled: "Cancelada",
        unpaid: "Impagada",
      },
      actions: {
        cancel: "Cancelar",
        pause: "Pausar",
        resume: "Reanudar",
      },
    },
    usage_section: {
      title: "Uso de emails",
      subtitle: "Consulta la cuota de tu equipo para el período actual.",
      loading: "Cargando el uso actual…",
      unavailable_title: "El uso no está disponible",
      unavailable_description:
        "No pudimos cargar tu cuota actual. Inténtalo nuevamente.",
      retry: "Volver a intentar",
      quota_title: "Cuota actual de emails",
      used_of: "{used} de {limit} emails utilizados",
      percent_used: "{percent}% utilizado",
      used: "Utilizados",
      remaining: "Disponibles",
      total: "Cuota total",
      billing_period: "Período de facturación",
      period_description: "El uso se reinicia al finalizar este período.",
      starts: "Comienza",
      resets: "Se reinicia",
      allowance_breakdown: "Detalle de la cuota",
      allowance_description:
        "Créditos disponibles para tu equipo durante este período.",
      source_plan: "Incluidos en el plan",
      source_credit_purchase: "Créditos adicionales",
      source_promotion: "Créditos promocionales",
      source_manual: "Ajuste manual",
      source_other: "Otros créditos",
      not_configured_title: "Cuota de emails sin configurar",
      not_configured_description:
        "Tu plan necesita una cuota personalizada antes de poder aceptar mensajes.",
      manage_plan: "Gestionar plan",
    },
    profile_section: {
      title: "Perfil",
      subtitle: "Actualiza tu información personal y contraseña.",
      personal_info: "Información personal",
      photo: "Foto de perfil",
      photo_hint: "JPG, PNG o WebP de hasta 2 MB.",
      choose_photo: "Elegir foto",
      save_photo: "Guardar foto",
      remove_photo: "Quitar foto",
      first_name_placeholder: "Tu nombre",
      last_name_placeholder: "Tu apellido",
      country_code: "Código país",
      phone: "Teléfono",
      change_password: "Cambiar contraseña",
      current_password: "Contraseña actual",
      new_password: "Nueva contraseña",
      repeat_new_password: "Repetir nueva contraseña",
      password_hint: "Mínimo 6 caracteres",
      repeat_password_hint: "Repite la nueva contraseña",
      language: "Idioma",
      language_hint: "Esta preferencia se aplicará al iniciar sesión en cualquier dispositivo.",
      timezone: "Zona horaria personal",
      timezone_hint: "Se usará primero al programar y mostrar emails. Puedes heredar la zona del equipo.",
      use_team_timezone: "Usar la zona horaria del equipo",
      languages: {
        en: "Inglés",
        es: "Español",
      },
      messages: {
        updated: "Perfil actualizado",
        password_updated: "Contraseña actualizada",
        fill_all_fields: "Completa todos los campos",
        passwords_mismatch: "Las contraseñas no coinciden",
        invalid_photo: "Selecciona una imagen JPG, PNG o WebP de hasta 2 MB.",
        photo_updated: "Foto de perfil actualizada",
        photo_removed: "Foto de perfil eliminada",
      },
    },
  },

  common: {
    saving: "Guardando...",
    updating: "Actualizando...",
    logo_alt: "Logo de Destinatarium",
    avatar_alt: "Avatar",
  },

  // Agrega aquí más traducciones en inglés
};
